import {
  ContractInfo,
  GetSmartSwapsParams,
} from 'api/types/httpsTypes/contracts';
import { useQuery } from '@tanstack/react-query';
import {
  ContractService,
  contractServiceKeys,
} from 'api/services/httpServices/ContractService';
import { duration } from 'moment';
import { desktopColumns } from '../../research/components/SmartSwaps/columns';
import {
  EmptyPageDex,
  ErrorPageDex,
} from '../../research/components/shared/Common';
import Table from 'modules/shared-components/data-display/table';
import Header from 'modules/shared-components/data-display/table/header';
import { TableRow } from '../../research/components/SmartSwaps/TableRow';
import { thDynamicClass } from '../../research/components/SmartSwaps';
import { TableColumn } from 'modules/shared-components/data-display/table/types';

interface Props {
  contract: ContractInfo;
}

export const SmartSwapsComponent = ({ contract }: Props) => {
  const params: GetSmartSwapsParams = {
    address: contract.generalInfo.address,
    chain: contract.generalInfo.chain.key,
  };

  const { data, error, isLoading } = useQuery({
    queryKey: contractServiceKeys.getSmartSwaps(params),
    queryFn: () => ContractService.getSmartSwaps(params),
    keepPreviousData: true,
    refetchInterval: duration(12, 'seconds').asMilliseconds(),
  });

  const columns = desktopColumns(true);

  return error ? (
    <ErrorPageDex />
  ) : (
    <div className="overflow-x-auto">
      <div className="w-full xxs:px-2">
        <Table className="xxs:[&_td:first-of-type:not(.details)]:pl-2 xxs:[&_th:first-of-type]:pl-2 lg:[&_td:first-of-type:not(.details)]:pl-6 lg:[&_th:first-of-type]:pl-6">
          <Header
            trClassName="lg:grid lg:grid-cols-6 xxs:dark:bg-dex-black-700 border-tailwind xxs:border-x-0 xxs:border-t-0 xxs:border-b-dex-black-600"
            columns={columns as TableColumn<any>[]}
            thDynamicClass={thDynamicClass}
            rowClassName="xxs:p-1 xxs:text-dex-white-secondary hover:text-dex-white"
            className="xxs:dark:bg-dex-black-700 hover:text-dex-white xxs:text-xs lg:grid"
          />
          <tbody>
            {isLoading ? (
              [...Array(10).keys()]
                .map((i) => i + 1)
                .map((index) => (
                  <Table.LoadingRow
                    thDynamicClass={thDynamicClass}
                    key={index}
                    elementClassName="xxs:dark:bg-dex-black-600"
                    className="lg:grid lg:grid-cols-8 xxs:bg-dex-black-700"
                    columns={columns as TableColumn<any>[]}
                  />
                ))
            ) : data?.length === 0 ? (
              <EmptyPageDex height="50px" title="No Smart Swaps Found" />
            ) : (
              data?.map((item, rowId) => (
                <TableRow
                  key={item.tokenAddress + '_' + item.chain + '_' + rowId}
                  data={item}
                  columnsDef={columns}
                  className="xxs:dark:bg-dex-black-700 lg:grid-cols-6 hover:dark:bg-dex-black-800 cursor-default	"
                />
              ))
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};
